import { StartSubscription } from "./start-subscription.js";
import { useSubscription } from "./subscription.context.jsx";

export const SubscriptionGuard = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { status } = useSubscription();

  if (status !== "inactive") {
    return children;
  }

  return <StartSubscription />;
};
